import React, { Fragment, useEffect } from "react";
import {
  statusAdministrationRender,
  statusRender,
} from "../utils/cellRenderTable";
import { useDispatch, useSelector } from "react-redux";

import AggridTable from "../components/Admin/Reusable/AggridTable";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import ButtonColumn from "../components/Admin/Reusable/ButtonColumn";
import { fetchUserList } from "../actions/user";
import { useTranslation } from "react-i18next";

const UserList = () => {
  const dispatch = useDispatch();

  const { userList } = useSelector((state) => state.userReducer);

  const { t } = useTranslation();
  //breadcrumb
  const translateModule = "users";
  const pageType = "List";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  useEffect(() => {
    dispatch(fetchUserList());
  }, [dispatch]);

  const customCellRenderer = (params) => {
    if (
      !params.data ||
      !params.data.id ||
      !params.data.name ||
      !params.data.lastName
    )
      return null;
    return (
      <ButtonColumn
        editLink={`/user-edit/` + params.data.id}
        // deleteItemId={params.data.id}
        // deleteItemTitle={`${params.data.name} ${params.data.lastName}`}
        value={params}
        // submitActionModal={handleSubmitModal}
      />
    );
  };

  const handleSubmitModal = (pageId) => {
    // dispatch(fetchDeleteUser(pageId));
    // alert(pageId);
  };

  //settings za tabelu
  const columnDefs = [
    {
      headerName: t("usersForm.country"),
      field: "countryName",
      filter: "agSetColumnFilter",
      enableRowGroup: true,
    },
    {
      headerName: t("usersForm.name"),
      field: "name",
      filter: "agTextColumnFilter",
      width: 200,
    },
    {
      headerName: t("usersForm.lastName"),
      field: "lastName",
      filter: "agTextColumnFilter",
      width: 200,
    },
    {
      headerName: t("usersForm.email"),
      field: "email",
      filter: "agTextColumnFilter",
      minWidth: 200,
      flex: 1,
    },
    {
      headerName: t("usersForm.accountType"),
      field: "accountType",
      filter: "agSetColumnFilter",
      cellRenderer: statusAdministrationRender,
      valueGetter: (params) => {
        if (!params.data || !params.data.accountType) return null;
        switch (params.data.accountType) {
          case "COUNTRY_ADMIN":
            return "Administrator države";
          case "SUPER_ADMIN":
            return "Master administrator";
          default:
            return "";
        }
      },
      enableRowGroup: true,
    },
    {
      headerName: t("usersForm.role"),
      field: "roleName",
      filter: "agSetColumnFilter",
      width: 200,
      enableRowGroup: true,
    },
    {
      headerName: "Status",
      field: "status",
      filter: "agSetColumnFilter",
      cellRenderer: statusRender,
      valueGetter: (params) => {
        if (!params.data || !params.data.status) return null;
        switch (params.data.status) {
          case "INACTIVE":
            return "Neaktivan";
          case "ACTIVE":
            return "Aktivan";
          default:
            return "";
        }
      },
    },
    {
      headerName: "",
      field: "custom",
      cellRenderer: customCellRenderer,
      pinned: "right",
      width: 60,
    },
  ];

  return (
    <Fragment>
      <Breadcrumb
        type={translateModule}
        pageType={pageType}
        breadcrumbItems={breadcrumbItems}
      />
      <AggridTable
        rowData={userList}
        columnDefs={columnDefs}
        buttonLink={`/user-add`}
        buttonText={t(`breadcrumb.${translateModule}Add`)}
        gridStateKey={"user-list"}
      />
    </Fragment>
  );
};

export default UserList;
